import React, { useState, useEffect } from 'react';
import { useSxStyles } from "../styles/sxStyles";
import { getDecimal } from '../config/utils'
import { dateIso2Us } from "../config/dateUtils";
import Grid2 from '@mui/material/Grid2';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from "@mui/material/Typography";
import ListItemText from '@mui/material/ListItemText';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';

const BondList = (props) => {
    const bonds = props.bonds;
    const balance = props.balance;
    const setPayIneligible = props.setPayIneligible;
    const classes = useSxStyles;
    const [bondId, setBondId] = useState(null);

    const handleBondClick = (e) => {
        const selectedBond = e.target.value;
        setBondId(selectedBond ? selectedBond : null);
    }

    const getBondAmount =  (bondIdIn) => {
        const filteredBonds = bonds.filter(b => b.bondId === bondIdIn);
        if (filteredBonds && filteredBonds.length > 0) return filteredBonds[0].bondAmount;
        return 0;
    }

    useEffect(() => {
        balance.bondId = bondId;
        balance.bondAmt = bondId ? getBondAmount(bondId) : null;
        setPayIneligible(bondId ? balance.refId : null);
    }, [bondId])

    return (<>
        <List sx={{...classes.list, maxHeight: '100%', marginLeft: '1rem'}} >
            <ListItem alignItems='flex-start' sx={classes.listPadding}>
                <ListItemText
                    sx={classes.listText}
                    primary={
                        <Grid2
                            container
                            spacing={1}
                            alignItems="top"
                        >
                            <Grid2 size={12}><Typography variant='subtitle2' sx={{color: 'sienna', fontSize: '1.2rem'}}>Bond(s)</Typography></Grid2>
                            <Grid2 size={3}>&nbsp;</Grid2>
                            <Grid2 sx={{ display: 'flex', justifyContent: 'flex-start' }} size={6}>Bond Type</Grid2>
                            <Grid2 style={{paddingLeft: '1rem'}} size={3}>Amount</Grid2>
                        </Grid2>
                    }
                    slotProps={{
                        primary: {
                            component: 'span',
                            color: 'textPrimary',
                            sx: {fontSize: '.9rem', lineHeight: '.7rem'},
                        }
                    }}
                />
            </ListItem>
            <RadioGroup name='bond' onChange={handleBondClick} value={bondId}>
                { bonds && bonds.length > 0 && bonds.map((bond) => {
                    return (
                        (<ListItem alignItems='flex-start' disableGutters sx={{paddingTop: '0', paddingBottom: '0'}}>
                            <ListItemText
                                sx={classes.listText}
                                primary={
                                    <Grid2
                                        container
                                        spacing={1}
                                        alignItems="top"
                                    >
                                        <Grid2 size={3}>
                                            <FormControlLabel
                                                value={bond.bondId}
                                                control={
                                                    <Radio
                                                        size='small'
                                                        defaultChecked={false}
                                                        sx={{marginLeft: '1rem', paddingBottom: '0', paddingLeft: '.5rem', paddingTop: '0', position: ''}}
                                                    />
                                                }
                                                label=''
                                                aria-label='select bond'
                                                sx={{paddingLeft: '0', paddingTop: '0'}}
                                            />
                                        </Grid2>
                                        <Grid2 sx={{ display: 'flex', justifyContent: 'flex-start' }} size={6}>{`${bond.bondType} ${bond.ineligibleUntilDate ? dateIso2Us(bond.ineligibleUntilDate) : ''}`}</Grid2>
                                        <Grid2
                                            sx={{textAlign: 'right', paddingRight: {xs: '0', sm: '10%', lg: '15%'}}}
                                            size={3}>{getDecimal(bond.bondAmount)}</Grid2>
                                    </Grid2>
                                }
                                slotProps={{
                                    primary: {
                                        component: 'span',
                                        color: 'textPrimary',
                                        sx: {fontSize: '.9rem', paddingLeft: '.2rem'}
                                    }
                                }}
                            />
                        </ListItem>)
                    );
                })}
                { bondId &&
                    <ListItem alignItems='flex-start' disableGutters sx={{paddingTop: '0', paddingBottom: '0'}}>
                        <ListItemText
                            sx={classes.listText}
                            primary={
                                <Grid2
                                    container
                                    spacing={1}
                                    alignItems="top"
                                >
                                    <Grid2 size={3}>
                                        <FormControlLabel
                                            value={null}
                                            control={
                                                <Radio
                                                    size='small'
                                                    sx={{marginLeft: '1rem', paddingBottom: '0', paddingLeft: '.5rem', paddingTop: '0', position: ''}}
                                                />
                                            }
                                            label=''
                                            sx={{paddingLeft: '0', paddingTop: '0'}}
                                        />
                                    </Grid2>
                                    <Grid2 size={9}>Remove bond selection</Grid2>
                                </Grid2>
                            }
                            slotProps={{
                                primary: {
                                    component: 'span',
                                    color: 'textPrimary',
                                    sx: {fontSize: '.9rem', paddingLeft: '.2rem'}
                                }
                            }}
                        />
                    </ListItem>
                }
            </RadioGroup>
        </List>
    </>);
}

export default BondList;
